export enum FeatureFlagEnum {
  sejamCheckEnabled,
  balanceIssueEnabled,
  supportFeedbackEnabled,
  changePasswordEnabled,
  creditEnabled,
  cardReissueEnabled,
  directPayEnabled,
  insuranceEnabled,
  openRequestEnabled,
  trustedDeviceEnabled,
  autoInvestEnabled,
  managementEnabled
}

export const flagKeyMap: Record<FeatureFlagEnum, string> = {
  [FeatureFlagEnum.balanceIssueEnabled]: 'balance-issue-enabled',
  [FeatureFlagEnum.supportFeedbackEnabled]: 'support-feedback-enabled',
  [FeatureFlagEnum.changePasswordEnabled]: 'change-password-enabled',
  [FeatureFlagEnum.creditEnabled]: 'credit-enabled',
  [FeatureFlagEnum.sejamCheckEnabled]: 'sejam-check-enabled',
  [FeatureFlagEnum.cardReissueEnabled]: 'card-reissue-enabled',
  [FeatureFlagEnum.directPayEnabled]: 'direct-pay-enabled',
  [FeatureFlagEnum.insuranceEnabled]: 'insurance-enabled',
  [FeatureFlagEnum.openRequestEnabled]: 'open-request-enabled',
  [FeatureFlagEnum.trustedDeviceEnabled]: 'trusted-device-enabled',
  [FeatureFlagEnum.autoInvestEnabled]: 'auto-invest-enabled',
  [FeatureFlagEnum.managementEnabled]: 'management-enabled',
};

export type TFeaturesResponse = string[];
